import React from 'react';
import { History } from 'history';
import { Input, InputFile, InputNumber, InputMultiline, InputSelect, Layout, InputSwitch, InputPicklist } from '../../components';
import BaseDelete from '../base/base-delete.component'; 
import Model from './report-model';  //editable..
import ReportList from './report-list.component';
import AppService from '../../services/app.service';

interface IProps { 
    history: History;
    root?: string;
}

interface IState {
    datarow: Model;
    errors: any;
}

export default class ReportDelete extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {
            datarow: Model.defaultValue(),
            errors: null,
        }
    }

    private onLoad = (data: any) => {
        this.setState({datarow:  data});
    }

    render() {
        return (
            //editable..
            <BaseDelete history={this.props.history} caption={this.state.datarow.parent && 'Delete ' +Model.caption+ ' Section'} 
                model={Model} onLoad={this.onLoad} disableCard>              

                <Layout history={this.props.history} direction={this.state.datarow.parent? 'column' : 'row'} content={[
                    {caption: 'Details', child: 
                    <>
                    <InputSwitch name='status' label='Status' value={this.state.datarow.status} options={Model.optionStatus} readOnly/>
                    <Input name='name' label='Name' value={this.state.datarow.name} readOnly/>
                    <InputMultiline name='description' label='Description' value={this.state.datarow.description} readOnly/>
                    {AppService.isAppFullVersion() &&
                    <InputPicklist name='owner' label='Owner' value={this.state.datarow.owner} caption={this.state.datarow.ownerCaption} readOnly/>
                    }
                    {this.state.datarow.parent &&
                    <Input name='parentCaption' label='Parent' value={this.state.datarow.parentCaption} readOnly/>
                    }
                    <Input name='title' label='Title' value={this.state.datarow.title} readOnly/>
                    <InputMultiline name='content' label='Content' value={this.state.datarow.content} readOnly/>
                    <InputNumber name='seq' label='Seq' value={this.state.datarow.seq} readOnly/>
                    <InputSelect name='type' label='Type' value={this.state.datarow.type} options={this.state.datarow.parent? Model.optionTypeSection : Model.optionType} readOnly/>
                    <InputFile name='imageUrl' label='Image' value={this.state.datarow.imageUrl} type='image' readOnly/>
                    <Input name='imagetitle' label='Image Title' value={this.state.datarow.imagetitle}/>

                    </>
                    },

                    {caption: 'Sections', hide: this.state.datarow.parent > 0, child: 
                    this.state.datarow.id > 0 && this.props.history &&
                        <ReportList history={this.props.history} root={this.props.root} caption='Report Section' parentId={this.state.datarow.id} actions={['view']} disableBackButton disableCard/>
                    },

                    ]}
                    
                />                
                                
            </BaseDelete>
        );
    }
}